import {useCallback, useEffect} from 'react';

import {registerDefaultHeader} from 'fetcher/useFetcher';

// import {useSnackbarStore} from 'store';
import {useUserStore} from './zustand';

export const useUserUtils = () => {
    const setUser = useUserStore((state) => state.setUser);
    const user = useUserStore((state) => state.user);
    const jwt = useUserStore((state) => state.user?.jwt);

    useEffect(() => {
        if (jwt) {
            registerDefaultHeader('Authorization', `Bearer ${jwt}`);
        } else {
            registerDefaultHeader('Authorization', undefined);
        }

        // migration must run if jwt changes only, i.e. user logs in/out
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jwt]);
    
    const logout = useCallback(() => {
        setUser(null);
    }, [setUser]);

    const isOwner = useCallback((haystack) => {
        if (Array.isArray(haystack)) {
            return haystack.includes(user.id);
        } else {
            return haystack === user?.id;
        }
    }, [user]);
    const isAuthenticated = !!user?.jwt;

    return {logout, isAuthenticated, isOwner};
};